import { render, staticRenderFns } from "./AuctionNotStarted.vue?vue&type=template&id=2f4a601e&"
import script from "./AuctionNotStarted.vue?vue&type=script&lang=js&"
export * from "./AuctionNotStarted.vue?vue&type=script&lang=js&"
import style0 from "./AuctionNotStarted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports